import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import commonProps from './common/common-props';
import SignInPane from './sign-in-elements/sign-in-pane';
import LivewireBrand from './common/livewire-brand';
import { Page } from './common/styles';

export default function SignIn(props) {
  const state = {
    ...props,
    ...commonProps(),
  };

  return (
    <ThemeProvider theme={state}>
      <Page>
        <LivewireBrand />
        <SignInPane />
      </Page>
    </ThemeProvider>
  );
}

/* eslint-disable react/no-unused-prop-types */
SignIn.propTypes = {
  logo: PropTypes.string.isRequired,
  redirectTo: PropTypes.string.isRequired,
  linkedInLogo: PropTypes.string.isRequired,
  linkedInAuthorizeUrl: PropTypes.string.isRequired,
};
/* eslint-enable react/no-unused-prop-types */
